/* eslint-disable */
import { sync } from 'vuex-router-sync';
import Vue from 'vue';
import App from './App.jsx';
import router from './router';
// import AsyncComputed from 'vue-async-computed'
import VueScrollTo from 'vue-scrollto';
import store from './store';
// import * as filters from './filters'
// import VueMask from 'v-mask'
import money from 'v-money';
import Utils from './utils';
import { getXUserKey, getXAPIEnv } from './plugins/account';
// import config from './config'
// import Modal from './plugins/modal'
// import VuePaginate from 'vue-paginate'
// import Vue2Filters from 'vue2-filters'
import VueTimers from 'vue-timers';
import { Internationalization } from './utils/Internationalization';
import Vue2TouchEvents from 'vue2-touch-events';
import PrototypePlugin from '@/plugins/prototypes';
import AppBridge from '@/plugins/app';
import DesktopBridge from '@/plugins/desktop';
import SocketIO from 'easyjs/lib/Socket/SocketIO';

import StoreAPI from './api/store';

import Mixpanel from 'mixpanel-browser';
import { Tracker } from 'easyjs/lib/Tools/Tracker';
import {
  MixPanelDriver,
  EVENTS as TrackEvents,
} from '@/plugins/trackDriver/MixPanelDriver';

import { OrderFakeApi } from '@/api/OrderFakeApi.js';

const customStorage = require('@/plugins/customStorage').default;

Vue.config.devtools = true;
window.StringLanguage = Internationalization.getDataByLanguage('pt-BR');
Vue.prototype.StringLanguage = Internationalization.getDataByLanguage('pt-BR');

window.URL_API_SERVICE = process.env.VUE_APP_URL_API_SERVICE;

function connectWS(env) {
  if (DesktopBridge.isDesktop()) {
    if (env) {
      DesktopBridge.emit('openWs', env);
    }
  }
}

function initSocket() {
  if (getXAPIEnv() && !Utils.empty(getXUserKey())) {
    SocketIO.open(process.env.VUE_APP_API_SOCKET, getXAPIEnv(), {
      transports: ['websocket', 'polling', 'flashsocket'],
      reconnection: true,
    });

    SocketIO.on({
      listener: 'service-notification',
      callback: (response) => {
        switch (response.notification) {
          case 'newOrders':
            if (DesktopBridge.isDesktop()) DesktopBridge.emit('hasNewOrder');
          case 'alreadyManipulatedOrders':
            if (!store.state.store.configurations.hasFirstOrder) {
              //Ao receber um novo pedido pelo socket, atualizar as configurações da loja com hasFirstOrder: true, recarregar as configurações e notificar recebimento do pedido
              StoreAPI.storeConfiguration({ hasFirstOrder: true }).then(() => {
                store.dispatch('store/getConfigurations', false);
                store.dispatch('socket/setSocketResponse', response);
              });
            } else {
              store.dispatch('socket/setSocketResponse', response);
            }
            break;
          case 'postponedOrders':
            store.dispatch('socket/removePostponedOrder', response);
            break;
          case 'newPostponedOrder':
            store.dispatch('socket/setPostponedOrder', response);
            break;
          case 'newAcceptedOrder':
            store.dispatch('socket/setNewAcceptedOrder', response);
            break;
          case 'newEditedOrder':
            store.dispatch('socket/setNewEditedOrder', response);
            break;
          case 'newCanceledOrder':
            store.dispatch('socket/setNewCanceledOrder', response);
            break;
          case 'newChangeOrderStatus':
            store.dispatch('socket/setNewChangeOrderStatus', response);
            break;
          case 'newChangeOrderDelivery':
            store.dispatch('socket/setNewChangeOrderDelivery', response);
            break;
          case 'cancelChangeOrderStatus':
            store.dispatch('socket/setCancelChangeOrderStatus', response);
            break;
          case 'storeStatus':
            store.dispatch('store/setConfigurations', response.data);
            break;
          case 'clientUpdate':
            if (DesktopBridge.isDesktop()) {
              DesktopBridge.emit('onClientUpdate');
            } else if (AppBridge.isApp()) {
              AppBridge.emit('onClientUpdate');
            } else {
              store.commit('store/setHasUpdate', true);
            }
            break;
        }
      },
    });

    // Faz o load dos pedidos adiados;
    store.dispatch('socket/getPostponedOrders');
  }
}

// const jivoChatEl = document.createElement('script');
// jivoChatEl.setAttribute('src', '//code-sa1.jivosite.com/widget/3LMk94uZlx');
// jivoChatEl.setAttribute('async', true);

router.beforeEach((to, from, next) => {
  //Limpar pedidos simulados na troca de rota:
  OrderFakeApi.clearOrders();

  let contentDiv = document.getElementById('content');
  if (contentDiv) {
    contentDiv.scrollTop = 0;
  }

  if (
    to.name !== 'login' &&
    to.name !== 'AccountCreate' &&
    to.name !== 'importador'
  ) {
    if (to.meta.needsAuth && Utils.empty(getXUserKey())) {
      router.push({ name: 'login' });
    }

    // Tracker.trigger(TrackEvents.CHANGED_ROUTE, {
    //   from: from.name,
    //   to: to.name
    // });

    const allowedRoutes = [
      'signup',
      'forgotpassword',
      'onboard',
      'configuracoes',
      'informacoes',
      'localizacao',
      'horario',
      'regioes',
      'pagamento',
      'sucesso-cadastro',
    ];
    if (!allowedRoutes.includes(to.name)) {
      const redirectToOnboard = !store.getters['store/isOnBoardDone'];

      if (redirectToOnboard) {
        router.push({ name: 'onboard' });
      }
    }
  } else {
    if (!Utils.empty(getXUserKey()) && to.name !== 'importador') {
      router.push({ name: 'pedidos' });
    }
  }

  store.commit('store/setLoading', false);
  if (DesktopBridge.isDesktop()) {
    if (Utils.empty(getXUserKey())) {
      //disconnect
      DesktopBridge.emit('closeWs');
    } else {
      //connect
      connectWS(customStorage().get.item('easy.account.x-api-env'));
    }
  }

  // store.dispatch('store/getIsOpen');

  //se a conexão com o socket estiver fechada, inicia
  if (!SocketIO.getSocket() || !SocketIO.getSocket().connected) initSocket();

  // store.dispatch('store/getInfo')
  // store.dispatch('store/getIsOpen')
  // setInterval(() => {
  //   store.dispatch('store/getIsOpen')
  // }, 600000)
  store.dispatch('account/getIsLogged');
  store.dispatch('account/getUser');

  // verificando as rotas para lidar com a exibição do chat
  // try {
  //   if (!Utils.empty(getXUserKey())) {
  //     if (!jivoChatEl.parentNode) {
  //       document.body.appendChild(jivoChatEl);
  //     }
  //   } else {
  //     if (jivoChatEl.parentNode) {
  //       document.body.removeChild(jivoChatEl);
  //
  //       if (!document.location.hash) {
  //         document.location = document.location + '#loaded';
  //         document.location.reload(true);
  //       }
  //     }
  //   }
  // } catch (err) {
  //   console.log(err);
  // }

  next();
});

String.prototype.toBytes = function () {
  var arr = [];
  for (var i = 0; i < this.length; i++) {
    arr.push(this[i].charCodeAt(0));
  }
  return arr;
};

sync(store, router);

Mixpanel.init(process.env.VUE_APP_MIXPANEL_TOKEN, { ignore_dnt: true });
const mixPanelDriver = new MixPanelDriver(Mixpanel);
Tracker.config(mixPanelDriver);
globalThis.Tracker = Tracker;

Vue.use(money, { precision: 4 });
Vue.use(VueScrollTo);
Vue.use(VueTimers);
Vue.use(Vue2TouchEvents, {
  swipeTolerance: 50,
});

new Vue({
  router,
  store,
  render: (h) => {
    return <App />;
  },
}).$mount('#app');
